import React from "react";

const QuoteFormSection = ({ title, subtitle, children }) => (
  <section className="quote-form-section">
    <div className="quote-form-section-header">
      <h3>{title}</h3>
      {subtitle && <p>{subtitle}</p>}
    </div>
    <div className="quote-form-section-body">{children}</div>
  </section>
);

export default React.memo(QuoteFormSection);
